import { HandleUploadFileResponse } from 'fetcher';
import { getThumbnailTypeFromPiclibFileUploadMediaFormat } from 'models';
import { FileUploadThumbnail, FILE_UPLOAD_THUMBNAIL_TYPE } from 'shared';

export const FILE_UPLOAD_RESULT_TYPE = {
  success: 'success',
  failure: 'failure',
} as const;

export type FileUploadResultSuccess = {
  type: typeof FILE_UPLOAD_RESULT_TYPE.success;
  fileSrn: string;
  thumbnail: FileUploadThumbnail | undefined;
};

export type FileUploadResultFailure = {
  type: typeof FILE_UPLOAD_RESULT_TYPE.failure;
  errorMessages: string[];
  // アクセスログ用のエラー種別
  errorTypes: string[];
};

export type FileUploadResult =
  | FileUploadResultSuccess
  | FileUploadResultFailure;

type GetThumbnailPayload = {
  file: File;
  attributeMap: HandleUploadFileResponse['mediaFileMetadata']['attributeMap'];
};

export const getThumbnail = ({
  file,
  attributeMap,
}: GetThumbnailPayload): Promise<FileUploadThumbnail> =>
  new Promise((resolve) => {
    const fileType = getThumbnailTypeFromPiclibFileUploadMediaFormat(
      attributeMap.MEDIA_FORMAT,
    );
    if (fileType !== FILE_UPLOAD_THUMBNAIL_TYPE.image) {
      resolve({
        type: fileType,
        name: attributeMap.ORIGINAL_NAME,
        url: '',
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      resolve({
        type: fileType,
        name: attributeMap.ORIGINAL_NAME,
        url: reader.result as string,
      });
    };
    reader.onerror = () => {
      resolve({
        type: fileType,
        name: attributeMap.ORIGINAL_NAME,
        url: '',
      });
    };
    reader.readAsDataURL(file);
  });
